import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { RmpvDetalheProdutivoFiltroComponent } from './rmpv-detalhe-produtivo-filtro/rmpv-detalhe-produtivo-filtro.component';
import { RmpvDetalheProdutivoListaComponent } from './rmpv-detalhe-produtivo-lista/rmpv-detalhe-produtivo-lista.component';
import { RmpvDetalheProdutivoServiceService } from './rmpv-detalhe-produtivo-service/rmpv-detalhe-produtivo-service.service';
import { RmpvDetalheProdutivoComponent } from './rmpv-detalhe-produtivo.component';


@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    NgbModule,
    TableModule,
    ButtonModule,
    TooltipModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  declarations: [
    RmpvDetalheProdutivoComponent,
    RmpvDetalheProdutivoFiltroComponent,
    RmpvDetalheProdutivoListaComponent
  ],
   exports: [
    RmpvDetalheProdutivoComponent
  ],
  providers: [
    RmpvDetalheProdutivoServiceService
  ]
})
export class RmpvDetalheProdutivoModule { }
